import React from 'react';
import classNames from 'classnames/bind';
import { Typography } from 'gd-design-library';
import { ImageTransformation, ProductDetailsCardListItem } from '@services';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cardListClassName = `${productDetailsItemClassName}__card-list`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsCardListItem;
}

export const CardList: React.FC<Props> = ({
  productDetailsItem: {
    card_list: {
      title,
      cards
    }
  }
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(productDetailsItemClassName) }>
      <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
        {title}
      </Typography>
      <div className={ cx(cardListClassName) } >
        {cards.map(card => (
          <div key={ card.title }>
            <img src={ imageTransformation.transformById(
              card.image[0].public_id,
              ALL_IMAGES_TRANSFORMATIONS
            ) } />
            <Typography variant='h5' >
              {card.title}
            </Typography>
            <Typography>
              {card.description}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};
